export const Heading = () => {
  return (
    <div
      css={`
        margin-bottom: 52px;
        font-size: 36px;
        font-style: normal;
        font-weight: 500;
        font-family: "Pretendard", sans-serif;
        line-height: 42px;
        letter-spacing: -0.576px;
        color: white;

        @media (min-width: 960px) {
          margin-bottom: 48px;
          line-height: 60px;
          font-size: 48px;
        }
      `}
    >
      Stay ahead of every case you handle for your clients and employees
    </div>
  );
};
